module.exports = __webpack_public_path__ + "img/contact.428ecbf5.svg";